import React from 'react';
import { LabelDetail, ValueDetail, ValueImage, ValueMSS } from '../../../../../component/page-components/detail';
import { convertToArrData } from '../../../../../util/Util';

const DriverProfileDeliveryAssociate = ({ data }) => {
  const {
    driver_type,
    trip_name,
    title_name,
    first_name,
    last_name,
    nik,
    phone,
    email,
    marital_status,
    date_of_birth,
    country_name,
    province_name,
    district_name,
    sub_district_name,
    urban_village_name,
    address,
    neighbour,
    hamlet,
    postal_code,
    shift_start_time,
    shift_end_time,
    emergency_contact_name,
    emergency_contact_address,
    emergency_contact_relationship,
    emergency_contact_no_hp,
    day_off,
    photo,
    birth_place,
    daily_salary,
    hourly_salary
  } = data;
  
  return (
    <>
      <div className=' mt-10 flex flex-col'>
        <p className=' font-roboto text-lg text-black-100 font-bold'>
          Driver Profile
        </p>
        <div className=' mt-3 flex flex-row'>
          <div className=' w-96'>
            <LabelDetail children='Driver Photo' />
            <ValueImage sources={photo} alt='driver-photo' />

            <LabelDetail children='Driver Type' />
            <ValueDetail children={driver_type ? driver_type : '-' } />

            <LabelDetail children='Ongoing Trip' />
            <ValueDetail children={trip_name ? trip_name : '-'} />
          </div>
          <div className=' w-96'>
            <LabelDetail children='Title' />
            <ValueDetail children={title_name ? title_name : ''} />

            <LabelDetail children='First Name' />
            <ValueDetail children={first_name ? first_name : '-'} />

            <LabelDetail children='Last Name' />
            <ValueDetail children={last_name ? last_name : '-'} />

            <LabelDetail children='NIK' />
            <ValueDetail children={nik ? nik : '-'} />

            <LabelDetail children='Phone' />
            <ValueDetail children={phone ? phone : '_' } />
          </div>
          <div className=' w-96'>
            <LabelDetail children='E-mail' />
            <ValueDetail children={email ? email : '-'} />

            <LabelDetail children='Marital Status' />
            <ValueDetail children={marital_status ? marital_status : '-'} />

            <LabelDetail children='Birth Place' />
            <ValueDetail children={birth_place ? birth_place : '-'} />

            <LabelDetail children='Birth Date' />
            <ValueDetail children={date_of_birth === '0001-01-01' ? '-' : date_of_birth} />
          </div>
        </div>
        <p className=' font-roboto text-lg text-black-100 font-bold mt-3'>
          Address Information
        </p>
        <div className=' mt-3 flex flex-row'>
          <div className=' w-96'>
            <LabelDetail children='Country' />
            <ValueDetail children={country_name ? country_name : '-'} />
            
            <LabelDetail children='Province' />
            <ValueDetail children={province_name ? province_name : '-'} />

            <LabelDetail children='District' />
            <ValueDetail children={district_name ? district_name : '-'} />
          </div>
          <div className=' w-96'>
            <LabelDetail children='Sub District' />
            <ValueDetail children={sub_district_name ? sub_district_name : '-'} />
            
            <LabelDetail children='Urban Village' />
            <ValueDetail children={urban_village_name ? urban_village_name : '-'} />

            <LabelDetail children='Address' />
            <ValueDetail children={address ? address : '-'} />
          </div>
          <div className=' w-96'>
            <LabelDetail children='Neighbourhood' />
            <ValueDetail children={neighbour ? neighbour : '-'} />
            
            <LabelDetail children='Hamlet' />
            <ValueDetail children={hamlet ? hamlet : '-'} />

            <LabelDetail children='Postal Code' />
            <ValueDetail children={postal_code ? postal_code : '-'} />
          </div>
        </div>
        <p className=' font-roboto text-lg text-black-100 font-bold mt-3'>
          Working Hours
        </p>
        <div className=' mt-3 flex flex-row'>
          <div className=' w-96'>
            <LabelDetail children='Shift Start' />
            <ValueDetail children={shift_start_time === '0001-01-01' ? '-' : shift_start_time} />
          
            <LabelDetail children='Daily Salary' />
            <ValueDetail children={daily_salary ? daily_salary : '-'} /></div>
          <div className=' w-96'>
            <LabelDetail children='Shift End' />
            <ValueDetail children={shift_end_time === '0001-01-01' ? '-' : shift_end_time} />
          
            <LabelDetail children='Hourly Salary' />
            <ValueDetail children={hourly_salary ? hourly_salary : '-'} /></div>
          <div className=' w-96'>
            <LabelDetail children='Day Off' />
            <ValueMSS data={convertToArrData(day_off)} />
          </div>
        </div>
        <p className=' font-roboto text-lg text-black-100 font-bold mt-3'>
          Emergency Contact
        </p>
        <div className=' mt-3 flex flex-row'>
          <div>
            <div className=' w-96'>
              <LabelDetail children='Name' />
              <ValueDetail children={emergency_contact_name ? emergency_contact_name : '-'} />
            </div>
            <div className=' w-96'>
              <LabelDetail children='Address' />
              <ValueDetail children={emergency_contact_address ? emergency_contact_address : '-'} />
            </div>
          </div>
          <div className=' w-96'>
            <LabelDetail children='Relationship' />
            <ValueDetail children={emergency_contact_relationship ? emergency_contact_relationship : '-'} />
          </div>
          <div className=' w-96'>
            <LabelDetail children='Phone' />
            <ValueDetail children={emergency_contact_no_hp ? emergency_contact_no_hp : '-'} />
          </div>
        </div>
      </div>
    </>
  );
}

export default DriverProfileDeliveryAssociate;